/**
 * 资源生命周期-资源申请模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const lifecycleResourceApplication = {
  // 查询AWS磁盘类型
  queryAWSVolumeType(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSVolumeType`, params);
  },
  // 查询AWS VPC
  queryAWSVpcList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSVpcList`, params);
  },
  // 查询AWS子网
  queryAWSSubnetList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSSubnetList`, params);
  },
  // 查询AWS子网
  queryAWSSubnetListByVpcId(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSSubnetListByVpcId`, params);
  },
  //查询AWS安全组
  queryAWSSecurityGroupList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSSecurityGroupList`, params);
  },
  //查询AWS可用区
  queryAWSAvailableZoneList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSAvailableZoneList`, params);
  },
  //查询AWS密钥对
  queryAWSKeyPairList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSKeyPairList`, params);
  },
  //查询Azure资源组
  queryResourceGroupList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryResourceGroupList`, params);
  },
  //获取Azure虚拟机机型列表
  listAzureVirtualMachineSizes(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAzureVirtualMachineSizes`, params);
  },
  // 获取Azure网络配置
  getAzureNetworkConfiguration(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/getAzureNetworkConfiguration`, params);
  },
  // 查询Azure磁盘类型
  queryAzureVolumeType(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAzureVolumeType`, params);
  },
  // 查询azure平台image类型
  listAzureImage(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAzureImage`, params);
  },
  // 查询azure镜像版本号
  listAzureImageVersion(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAzureImageVersion`, params);
  },
  //提交资源申请
  submitLifecycleResourceApplication(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/submitLifecycleResourceApplication`, params);
  },
  //提交资源变更
  submitLifecycleResourceChange(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceChange/submitLifecycleResourceChange`, params);
  },
  //提交资源续约
  submitLifecycleResourceRenew(params) {
    return $http.post(`${global.API_URL}/sme/LifecycleResourceRenew/submitLifecycleResourceRenew`, params);
  },
  //提交资源回收
  submitLifecycleResourceRecycle(params) {
    return $http.post(`${global.API_URL}/sme/LifecycleResourceRecycle/submitLifecycleResourceRecycle`, params);
  },
  // 查询存储桶名称
  queryAWSBucketList(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAWSBucketList`, params);
  },
  // 公共访问级别
  queryAzurePublicAccesses(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAzurePublicAccesses`, params);
  },
  // 存储账户
  queryAzureStorageAccounts(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryAzureStorageAccounts`, params);
  },
  // 查询Redis的定价层
  listAzureRedisPricingTierDTO(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAzureRedisPricingTierDTO`, params);
  },
  // 获取可变更的资源列表
  listLifecycleResource(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listLifecycleResource`, params);
  },
  // 获取可变更的资源列表分页
  listLifecycleResourceByPage(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listLifecycleResourceByPage`, params);
  },
  // 查询RDS引擎列表
  listAWSRDSEngine(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAWSRDSEngine`, params);
  },
  // RDS版本 列表
  listAWSRDSVersions(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAWSRDSVersions`, params);
  },
  // RDS引擎版本列表
  listAWSRDSEngineVersions(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAWSRDSEngineVersions`, params);
  },
  // 参数组列表
  listAWSRDSdescribeDBParameterGroups(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/listAWSRDSdescribeDBParameterGroups`, params);
  },
  // 选项组 列表
  describeOptionGroups(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/describeOptionGroups`, params);
  },
  // 安全组
  describeSecurityGroups(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/describeSecurityGroups`, params);
  },
  // 查询引擎参数组
  queryDbParameterGroupFamily(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryDbParameterGroupFamily`, params);
  },
  // 查询根据资源ID查询资源
  queryLifecycleResourceById(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryLifecycleResourceById`, params);
  },
  // 查询RI价格
  queryReservedInstancesPrice(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/queryReservedInstancesPrice`, params);
  },
  // 根据价格切换审批流
  switchApprovalStreamsBasedByPrice(params) {
    return $http.post(`${global.API_URL}/sme/lifecycleResourceApplication/switchApprovalStreamsBasedByPrice`, params);
  },

};

export default lifecycleResourceApplication;



// WEBPACK FOOTER //
// ./src/api/lifecycleResourceApplication.js